module.exports = __webpack_public_path__ + "static/media/Mt.FujiJapan-night.e556621d.svg";